import { Cohort } from '@afterpaytouch/portal-api/types'
import { PaymentType } from '@afterpay/types'
import { Theme } from '@afterpaytouch/core'
import { i18n, TFunction } from 'i18next'
import { Route } from '../config/routes'
import { ParsedUrlQueryInput } from 'querystring'

export const CONVERGENCE_NAMESPACE = '__cash'
export const NAMESPACE_SEPARATOR = ':'
export const LEGAL_PREFIX = '|░legal░|'
export const THEME_COOKIE_NAME = 'x-apt-theme'
// Apateu, Apateu
export const COHORT_COOKIE_NAME = 'apt-cohort'
export const LAST_USED_EMAIL_DOMAIN_COOKIE_NAME = 'apt-last-used-email-domain'
export const MERCHANT_ID_COOKIE_NAME = 'apt-merchant-id'
export const NO_MERCHANT_ID_IN_COOKIE = 'NO_MERCHANT_ID_IN_COOKIE'
export const MERCHANT_ORDER_SOURCE = 'apt-merchant-order-source'
export const IN_APP_BROWSER_COOKIE_NAME = 'apt-in-app-browser'

export interface SetThemeRequest {
  theme: Theme
}

export enum ConvergenceUnavailable {
  Unavailable = 'Unavailable',
}

export enum ConvergenceAvailable {
  GA = 'GA', // Arcade Cash Green
  Pegasus = 'Pegasus', // Arcade Monochrome
  Kelpie = 'Kelpie', // Arcade Monochrome Mint
}

export enum ConvergenceCashLogin {
  Enabled = 'Enabled',
  DisabledNew = 'Disabled New',
  DisabledAll = 'Disabled All',
}

export type ConvergenceRollout = ConvergenceAvailable | ConvergenceUnavailable

export const availableRollouts: ConvergenceRollout[] = [ConvergenceAvailable.GA, ConvergenceAvailable.Pegasus, ConvergenceAvailable.Kelpie]

export const allowedPaymentTypeByRolloutAndCohort: Record<ConvergenceRollout, Record<Cohort, PaymentType[]>> = {
  [ConvergenceAvailable.GA]: {
    [Cohort.CashOnly]: [PaymentType.PBI],
    [Cohort.APOnly]: [PaymentType.PBI, PaymentType.PCL],
    [Cohort.NetNew]: [PaymentType.PBI, PaymentType.PCL],
  },
  [ConvergenceAvailable.Pegasus]: {
    [Cohort.CashOnly]: [PaymentType.PBI],
    [Cohort.APOnly]: [PaymentType.PBI, PaymentType.PCL],
    [Cohort.NetNew]: [PaymentType.PBI, PaymentType.PCL],
  },
  [ConvergenceAvailable.Kelpie]: {
    [Cohort.CashOnly]: [PaymentType.PBI],
    [Cohort.APOnly]: [PaymentType.PBI, PaymentType.PCL],
    [Cohort.NetNew]: [PaymentType.PBI, PaymentType.PCL],
  },
  [ConvergenceUnavailable.Unavailable]: {
    [Cohort.CashOnly]: [],
    [Cohort.APOnly]: [PaymentType.PBI, PaymentType.PCL],
    [Cohort.NetNew]: [PaymentType.PBI, PaymentType.PCL],
  },
}

export const convergenceThemes = ['Unicorn' as Theme, 'Pegasus' as Theme, 'Kelpie' as Theme]

export const blackListedShadowAccountThemes = ['Narwhal' as Theme]

export const mapRolloutToTheme: Record<ConvergenceRollout, Theme> = {
  [ConvergenceAvailable.Pegasus]: 'Pegasus' as Theme,
  [ConvergenceAvailable.Kelpie]: 'Kelpie' as Theme,
  [ConvergenceAvailable.GA]: 'Unicorn' as Theme,
  [ConvergenceUnavailable.Unavailable]: 'Narwhal' as Theme,
}

export interface ConvergenceTrackingProps {
  customerCohort?: Cohort
  checkoutBrand?: Theme
  convergenceRollout?: ConvergenceRollout
  cashLoginAvailability?: ConvergenceCashLogin
}

export enum ConvergenceAuthMethod {
  MobileRedirect = 'mobile redirection',
  DesktopRedirect = 'desktop redirection',
  QrCode = 'qr code',
}

export interface ConvergenceRedirectProps {
  method: ConvergenceAuthMethod
  url: string
}

export interface UseCustomTranslationResponse {
  t: TFunction
  i18n: i18n
  ready: boolean
}

type Stringify<T> = {
  [K in keyof T]: string
}

// Since these query params are passed as strings, we need to convert them to
// The actual values on the page, in getServerSideProps
export type InitialLoadingRouteProps = Stringify<InitialLoadingRouteConvertedProps> & ParsedUrlQueryInput

export interface InitialLoadingRouteConvertedProps {
  nextRoute?: Route
  hasNoExistingLoginIdentity?: boolean
  isShadowAccount: boolean
  isPersistentLogin?: boolean
}

export enum PayMonthlyRedesignRollout {
  GA = 'GA',
  ARCADE = 'Arcade',
  DEFAULT = 'Default',
}
